<template>
	<div class="upnext-flyout-container">
		<div
			class="upnext-flyout"
		>
			<span
				class="upnext-flyout-caret webmd-icon-right-arrow"
				v-show="isVisible"
				@click="isVisible = false"
			>
			</span>
			<span
				class="upnext-flyout-caret webmd-icon-left-arrow"
				v-show="!isVisible"
				@click="isVisible = true"
			>
			</span>
			<div
				class="upnext-flyout-contents"
				v-show="isVisible"
			>
				<div class="upnext-flyout-text">
					<span class="upnext-flyout-header">
						Next Video
					</span>
					<div
						class="item"
						:content="nextTitle"
						placement="bottom-start"
					>
						<h3>{{ nextTitle }}</h3>
					</div>
				</div>
				<img
					class="upnext-flyout-thumb"
					:src="nextThumb"
					:alt="nextAlt"
				/>
				<span class="upnext-flyout-playicon"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UpNext',
	data() {
		return {
			isVisible: true,
		};
	},
	props: {
		nextTitle: {
			type: String,
			default: '',
		},

		/* TODO: We need a default thumbnail source in case the image is missing */
		nextThumb: {
			type: String,
			default: '',
		},
		nextAlt: {
			type: String,
			default: 'Next Video',
		},
	},
};

</script>
